import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: 'app-shop',
  templateUrl: './shop.component.html',
  styleUrls: ['./shop.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ShopComponent implements OnInit {

  public deeplink;

  constructor(public route:ActivatedRoute, public sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      let id = params['id']
      let route = params['route']
      let forceAddone = params['addon']
      let addon = ''
      console.log(route)
      console.log(id)
      if(route==undefined || route == ''){
        route = 'items'
      }else if(route=="_browseItem"){
        addon = '/0' 
      }else if(route=="_items"){
        if(forceAddone!==undefined){
          addon = "/"+forceAddone
        }else{
          addon = '/1'
        }   
      }

      if(id==undefined || id==''){
        this.deeplink = this.sanitizer.bypassSecurityTrustResourceUrl("https://market.kryptomon.co/"+route+"/")
        console.log(this.deeplink)
      }else{
        this.deeplink = this.sanitizer.bypassSecurityTrustResourceUrl("https://market.kryptomon.co/"+route+"/"+id+addon)
        console.log(this.deeplink)
      }
  });
  }

}
